import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Accueil from './pages/Accueil';
import HallOfFame from './pages/HallOfFame';
import Smasheurs from './pages/Smasheurs';
import SmasheurDetail from './pages/SmasheurDetail';
import Tournois from './pages/Tournois';
import TournoiDetail from './pages/TournoiDetail';
import Anecdotes from './pages/Anecdotes';
import TropheesPublic from './pages/TropheesPublic';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main role="main" className="container-xl mb-4">
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/hall-of-fame" element={<HallOfFame />} />
            <Route path="/smasheurs" element={<Smasheurs />} />
            <Route path="/smasheurs/:id" element={<SmasheurDetail />} />
            <Route path="/tournois" element={<Tournois />} />
            <Route path="/tournois/:id" element={<TournoiDetail />} />
            <Route path="/anecdotes" element={<Anecdotes />} />
            <Route path="/trophees" element={<TropheesPublic />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;